import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

interface SuccessModalProps {
  show: boolean;
  title?: string;
  message?: string | React.ReactNode;

  onClose: () => void;

  /** Optional auto-close countdown (seconds). If provided, the modal shows a timer and auto-closes. */
  autoCloseSeconds?: number;

  /** Optional: Called when countdown reaches 0, before closing. */
  onRedirect?: () => void;

  closeText?: string;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
  show,
  title = "Success",
  message = "Submitted.",
  onClose,
  autoCloseSeconds,
  onRedirect,
  closeText = "OK",
}) => {
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null);

  useEffect(() => {
    if (!show) {
      setSecondsLeft(null);
      return;
    }

    if (typeof autoCloseSeconds === "number" && autoCloseSeconds > 0) {
      setSecondsLeft(autoCloseSeconds);
    } else {
      setSecondsLeft(null);
    }
  }, [show, autoCloseSeconds]);

  useEffect(() => {
    if (!show) return;
    if (secondsLeft === null) return;
    if (secondsLeft <= 0) {
      onRedirect?.();
      onClose();
      return;
    }

    const t = window.setTimeout(() => setSecondsLeft((s) => (s === null ? null : s - 1)), 1000);
    return () => window.clearTimeout(t);
  }, [show, secondsLeft, onRedirect, onClose]);

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className="bg-success text-white">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {typeof message === "string" ? (
          <div dangerouslySetInnerHTML={{ __html: message }} />
        ) : (
          message
        )}

        {secondsLeft !== null ? (
          <div className="small text-muted mt-2">
            Closing in <span className="fw-semibold">{secondsLeft}s</span>…
          </div>
        ) : null}
      </Modal.Body>

      <Modal.Footer className="justify-content-end">
        <Button variant="success" onClick={onClose}>
          {closeText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessModal;